import { compose } from 'ramda'
import { withAnalytics } from 'hocs/withAnalytics'
import withAuth from 'hocs/withAuth'
import { withCookies } from 'hocs/withCookies'
import { withGql } from 'hocs/withGql'
import withVertical from 'hocs/withVertical'
import { CompanyArticlesPage } from 'containers/company-articles/page'

export default compose(
    withGql({}),
    withAuth({
        isPublicPage: true,
    }),
    withVertical,
    withCookies,
    withAnalytics({ pageNameForAnalytics: 'Company Articles' }),
)(CompanyArticlesPage)
